import { useState } from 'react';

export const useSubmitData = (submitFn) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const submit = async (payload) => {
        setLoading(true);
        try {
            const result = await submitFn(payload);
            return result;
        } catch (err) {
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { submit, loading };
};
